module.exports = __webpack_public_path__ + "img/mujer_up.e906a96e.png";